import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import handleNavigate from "./customFunctions/handleNavigate";

export default function BasicBreadcrumbs({ breadcrumbs }) {
    const { t } = useTranslation();
    const theme = useTheme();
    const navigate = useNavigate();
    const handleClick = (event, navItemHref) => {
        const url = navItemHref.startsWith("/") ? navItemHref : `/${navItemHref}`;
        handleNavigate(event, navigate, url);
    };
    return (
        <div role="presentation" style={{ width: "100%" }}>
            <Breadcrumbs
                aria-label="breadcrumb"
                sx={{
                    color: theme.palette.custom.text,
                    width: "100%",
                }}
                separator={<NavigateNextIcon fontSize="small" />}
            >
                {breadcrumbs && breadcrumbs.length > 0
                    ? breadcrumbs.map((item, index) => (
                        <Link
                            key={index}
                            onClick={(e) => handleClick(e, item.href)}
                            // onClick={() => handleClick(item.href)}
                            sx={{
                                color: theme.palette.custom.text,
                                cursor: "pointer",
                            }}
                            underline="hover"
                        // href={item.href}
                        >
                            {item.noTranslation ? item.name : t(item.name)}
                        </Link>
                    ))
                    : null}
            </Breadcrumbs>
        </div>
    );
}
BasicBreadcrumbs.propTypes = {
    breadcrumbs: PropTypes.array,
};
